import { mainnet, sepolia, base } from "viem/chains";
import { getOrMapViemChain } from "@dynamic-labs/ethereum-core";

export const customEvmNetworks = [
  {
    blockExplorerUrls: ["http://localhost:8545"],
    chainId: 31337,
    chainName: "Localhost",
    iconUrls: ["https://app.dynamic.xyz/assets/networks/eth.svg"],
    name: "Localhost",
    nativeCurrency: {
      decimals: 18,
      name: "Ether",
      symbol: "ETH",
      iconUrl: "https://app.dynamic.xyz/assets/networks/eth.svg",
    },
    networkId: 31337,
    rpcUrls: ["http://localhost:8545"],
  },
];

export const evmNetworks = [
  {
    blockExplorerUrls: ["https://etherscan.io/"],
    chainId: 1,
    chainName: "Ethereum Mainnet",
    iconUrls: ["https://app.dynamic.xyz/assets/networks/eth.svg"],
    name: "Ethereum",
    nativeCurrency: {
      decimals: 18,
      name: "Ether",
      symbol: "ETH",
      iconUrl: "https://app.dynamic.xyz/assets/networks/eth.svg",
    },
    networkId: 1,
    rpcUrls: ["https://mainnet.infura.io/v3/"],
    vanityName: "ETH Mainnet",
  },
  {
    blockExplorerUrls: ["https://sepolia.etherscan.io/"],
    chainId: 11155111,
    chainName: "Sepolia Testnet",
    iconUrls: ["https://app.dynamic.xyz/assets/networks/eth.svg"],
    name: "Sepolia",
    nativeCurrency: {
      decimals: 18,
      name: "Ether",
      symbol: "ETH",
      iconUrl: "https://app.dynamic.xyz/assets/networks/eth.svg",
    },
    networkId: 11155111,
    rpcUrls: ["https://sepolia.infura.io/v3/"],
  },
  {
    blockExplorerUrls: ["https://base.blockscout.com/"],
    chainId: 8453,
    chainName: "Base Mainnet",
    iconUrls: ["https://app.dynamic.xyz/assets/networks/eth.svg"],
    name: "Base",
    nativeCurrency: {
      decimals: 18,
      name: "Ether",
      symbol: "ETH",
      iconUrl: "https://app.dynamic.xyz/assets/networks/eth.svg",
    },
    networkId: 8453,
    rpcUrls: ["https://base.infura.io/v3/"],
  },
  ...customEvmNetworks,
];

export const wagmiChains = [
  mainnet,
  sepolia,
  base,
  ...customEvmNetworks.map(getOrMapViemChain),
];

export type NetworkEnvironment =
  | "development"
  | "testnet-sepolia"
  | "testnet-sepolia-staging";

// Get the network environment from VITE_NODE_ENV env var
export const getNetworkEnvironment = (): NetworkEnvironment => {
  const nodeEnv = import.meta.env.VITE_NODE_ENV;

  if (nodeEnv === "development") {
    return "development";
  } else if (nodeEnv === "testnet-sepolia-staging") {
    return "testnet-sepolia-staging";
  }

  // Default to testnet-sepolia
  return "testnet-sepolia";
};

// Get the chain configuration for the current network
export const getChainConfig = () => {
  const networkEnv = getNetworkEnvironment();

  if (networkEnv === "development") {
    return customEvmNetworks[0]; // Return localhost config
  }

  // For both testnet-sepolia and testnet-sepolia-staging, use sepolia chain
  return sepolia;
};
